// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cumulative-topics {
  position: absolute;
  z-index: 45;
}

.cumulative-topics--desktop {
  left: 1rem;
}

.cumulative-topics--mobile {
  position: relative;
  z-index: 55;
  flex: 0 0 auto;
}

.cumulative-topics__trigger {
  position: relative;
  width: 2.25rem;
  height: 2.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid #e5e7eb;
  border-radius: 7px;
  background: var(--surface-color);
  color: #4b5563;
  cursor: pointer;
  box-shadow: none;
  transition: background 0.16s ease, border-color 0.16s ease, color 0.16s ease, transform 0.16s ease;
}

.cumulative-topics__trigger:hover,
.cumulative-topics--open .cumulative-topics__trigger {
  background: #f9fafb;
  border-color: #d1d5db;
  color: #374151;
  transform: none;
}

.cumulative-topics__trigger svg {
  width: 1.15rem;
  height: 1.15rem;
}

.cumulative-topics__badge {
  position: absolute;
  top: -0.42rem;
  right: -0.42rem;
  min-width: 1.12rem;
  height: 1.12rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.27rem;
  border: 2px solid #ffffff;
  border-radius: 999px;
  background: #dc2626;
  color: #ffffff;
  font-size: 0.62rem;
  font-weight: 800;
  line-height: 1;
  box-sizing: border-box;
  box-shadow: 0 2px 5px rgba(127, 29, 29, 0.35);
}

.cumulative-topics__panel {
  position: absolute;
  left: 0;
  bottom: calc(100% + 0.6rem);
  width: min(20rem, calc(100vw - 2rem));
  max-height: min(25rem, 58vh);
  overflow-y: auto;
  padding: 0.9rem;
  border: 1px solid #dbe3ee;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.98);
  color: #1f2937;
  box-shadow: none;
}

.cumulative-topics--mobile .cumulative-topics__panel {
  left: auto;
  right: 0;
  top: calc(100% + 0.6rem);
  bottom: auto;
  max-height: min(25rem, calc(100vh - 8rem));
}

.cumulative-topics__heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding-bottom: 0.65rem;
  border-bottom: 1px solid #e5e7eb;
}

.cumulative-topics__client-description {
  margin-bottom: 0.78rem;
  padding-bottom: 0.78rem;
  border-bottom: 1px solid #e5e7eb;
}

.cumulative-topics__client-description h4 {
  margin: 0;
  color: #1f2937;
  font-size: 0.82rem;
  font-weight: 750;
}

.cumulative-topics__client-description p {
  margin: 0.38rem 0 0;
  color: #4b5563;
  font-size: 0.8rem;
  line-height: 1.42;
}

.cumulative-topics__heading h4,
.cumulative-topics__category h5 {
  margin: 0;
}

.cumulative-topics__heading h4 {
  font-size: 0.8rem;
  font-weight: 750;
}

.cumulative-topics__heading span {
  color: #6b7280;
  font-size: 0.72rem;
  font-weight: 700;
}

.cumulative-topics__category {
  margin-top: 0.78rem;
}

.cumulative-topics__category h5 {
  color: #2563eb;
  font-size: 0.78rem;
  font-weight: 750;
}

.cumulative-topics__category ul {
  margin: 0.38rem 0 0;
  padding-left: 1.1rem;
}

.cumulative-topics__category li,
.cumulative-topics__empty {
  color: #4b5563;
  font-size: 0.8rem;
  line-height: 1.42;
}

.cumulative-topics__category li + li {
  margin-top: 0.32rem;
}

.cumulative-topics__empty {
  margin: 0.75rem 0 0;
}

.dark .cumulative-topics__trigger {
  border-color: #4b5563;
  background: #374151;
  color: #d1d5db;
  box-shadow: none;
}

.dark .cumulative-topics__trigger:hover,
.dark .cumulative-topics--open .cumulative-topics__trigger {
  border-color: #64748b;
  background: #4b5563;
  color: #f3f4f6;
  transform: none;
}

.dark .cumulative-topics__badge {
  border-color: #1f2937;
}

.dark .cumulative-topics__panel {
  border-color: #4b5563;
  background: rgba(31, 41, 55, 0.99);
  color: #f3f4f6;
  box-shadow: none;
}

.dark .cumulative-topics__heading {
  border-color: #4b5563;
}

.dark .cumulative-topics__client-description {
  border-color: #4b5563;
}

.dark .cumulative-topics__client-description h4 {
  color: #f3f4f6;
}

.dark .cumulative-topics__client-description p {
  color: #d1d5db;
}

.dark .cumulative-topics__heading span,
.dark .cumulative-topics__category li,
.dark .cumulative-topics__empty {
  color: #d1d5db;
}

@media (max-width: 700px) {
  .cumulative-topics__trigger {
    width: 2.18rem;
    height: 2.18rem;
    box-shadow: none;
  }

  .cumulative-topics__panel {
    width: min(19rem, calc(100vw - 1.5rem));
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/chat/CumulativeTopicsPopover.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kGAAkG;AACpG;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,2BAA2B;EAC3B,qCAAqC;EACrC,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,wBAAwB;EACxB,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,uCAAuC;EACzC;AACF","sourcesContent":[".cumulative-topics {\n  position: absolute;\n  z-index: 45;\n}\n\n.cumulative-topics--desktop {\n  left: 1rem;\n}\n\n.cumulative-topics--mobile {\n  position: relative;\n  z-index: 55;\n  flex: 0 0 auto;\n}\n\n.cumulative-topics__trigger {\n  position: relative;\n  width: 2.25rem;\n  height: 2.25rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 1px solid #e5e7eb;\n  border-radius: 7px;\n  background: var(--surface-color);\n  color: #4b5563;\n  cursor: pointer;\n  box-shadow: none;\n  transition: background 0.16s ease, border-color 0.16s ease, color 0.16s ease, transform 0.16s ease;\n}\n\n.cumulative-topics__trigger:hover,\n.cumulative-topics--open .cumulative-topics__trigger {\n  background: #f9fafb;\n  border-color: #d1d5db;\n  color: #374151;\n  transform: none;\n}\n\n.cumulative-topics__trigger svg {\n  width: 1.15rem;\n  height: 1.15rem;\n}\n\n.cumulative-topics__badge {\n  position: absolute;\n  top: -0.42rem;\n  right: -0.42rem;\n  min-width: 1.12rem;\n  height: 1.12rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 0.27rem;\n  border: 2px solid #ffffff;\n  border-radius: 999px;\n  background: #dc2626;\n  color: #ffffff;\n  font-size: 0.62rem;\n  font-weight: 800;\n  line-height: 1;\n  box-sizing: border-box;\n  box-shadow: 0 2px 5px rgba(127, 29, 29, 0.35);\n}\n\n.cumulative-topics__panel {\n  position: absolute;\n  left: 0;\n  bottom: calc(100% + 0.6rem);\n  width: min(20rem, calc(100vw - 2rem));\n  max-height: min(25rem, 58vh);\n  overflow-y: auto;\n  padding: 0.9rem;\n  border: 1px solid #dbe3ee;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.98);\n  color: #1f2937;\n  box-shadow: none;\n}\n\n.cumulative-topics--mobile .cumulative-topics__panel {\n  left: auto;\n  right: 0;\n  top: calc(100% + 0.6rem);\n  bottom: auto;\n  max-height: min(25rem, calc(100vh - 8rem));\n}\n\n.cumulative-topics__heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding-bottom: 0.65rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.cumulative-topics__client-description {\n  margin-bottom: 0.78rem;\n  padding-bottom: 0.78rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.cumulative-topics__client-description h4 {\n  margin: 0;\n  color: #1f2937;\n  font-size: 0.82rem;\n  font-weight: 750;\n}\n\n.cumulative-topics__client-description p {\n  margin: 0.38rem 0 0;\n  color: #4b5563;\n  font-size: 0.8rem;\n  line-height: 1.42;\n}\n\n.cumulative-topics__heading h4,\n.cumulative-topics__category h5 {\n  margin: 0;\n}\n\n.cumulative-topics__heading h4 {\n  font-size: 0.8rem;\n  font-weight: 750;\n}\n\n.cumulative-topics__heading span {\n  color: #6b7280;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.cumulative-topics__category {\n  margin-top: 0.78rem;\n}\n\n.cumulative-topics__category h5 {\n  color: #2563eb;\n  font-size: 0.78rem;\n  font-weight: 750;\n}\n\n.cumulative-topics__category ul {\n  margin: 0.38rem 0 0;\n  padding-left: 1.1rem;\n}\n\n.cumulative-topics__category li,\n.cumulative-topics__empty {\n  color: #4b5563;\n  font-size: 0.8rem;\n  line-height: 1.42;\n}\n\n.cumulative-topics__category li + li {\n  margin-top: 0.32rem;\n}\n\n.cumulative-topics__empty {\n  margin: 0.75rem 0 0;\n}\n\n.dark .cumulative-topics__trigger {\n  border-color: #4b5563;\n  background: #374151;\n  color: #d1d5db;\n  box-shadow: none;\n}\n\n.dark .cumulative-topics__trigger:hover,\n.dark .cumulative-topics--open .cumulative-topics__trigger {\n  border-color: #64748b;\n  background: #4b5563;\n  color: #f3f4f6;\n  transform: none;\n}\n\n.dark .cumulative-topics__badge {\n  border-color: #1f2937;\n}\n\n.dark .cumulative-topics__panel {\n  border-color: #4b5563;\n  background: rgba(31, 41, 55, 0.99);\n  color: #f3f4f6;\n  box-shadow: none;\n}\n\n.dark .cumulative-topics__heading {\n  border-color: #4b5563;\n}\n\n.dark .cumulative-topics__client-description {\n  border-color: #4b5563;\n}\n\n.dark .cumulative-topics__client-description h4 {\n  color: #f3f4f6;\n}\n\n.dark .cumulative-topics__client-description p {\n  color: #d1d5db;\n}\n\n.dark .cumulative-topics__heading span,\n.dark .cumulative-topics__category li,\n.dark .cumulative-topics__empty {\n  color: #d1d5db;\n}\n\n@media (max-width: 700px) {\n  .cumulative-topics__trigger {\n    width: 2.18rem;\n    height: 2.18rem;\n    box-shadow: none;\n  }\n\n  .cumulative-topics__panel {\n    width: min(19rem, calc(100vw - 1.5rem));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
